import type { SubstitutoFornecedorStepProps } from "./types-substituto-fornecedor-step";
import { useSubstitutoFornecedorStep } from "./use-substituto-fornecedor-step";
import { SubstitutoFornecedorStepView } from "./view-substituto-fornecedor-step";

export function SubstitutoFornecedorStep(props: SubstitutoFornecedorStepProps) {
  const vm = useSubstitutoFornecedorStep(props);

  return <SubstitutoFornecedorStepView {...vm} />;
}

export type * from "./types-substituto-fornecedor-step";
